import * as types from './countryActionTypes';

export default (
  state = {
    selected: null,
    loading: false,
    countries: [],
    error: '',
  },
  action
) => {
  switch (action.type) {
    case types.GET_COUNTRIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.countries,
      };
    case types.GET_COUNTRIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.SELECT_COUNTRY:
      return {
        ...state,
        selected: action.countrySfId,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/country/countryReducer.js